import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Layout } from "../components/Layout";
import { api } from "../api/client";
import { TENANT_STATUSES, tenantStatusBadge, tenantStatusLabel } from "../lib/tenants";

const COLUMNS = ["Name", "Building", "Unit", "Status", "Phone"];

export function TenantsPage() {
  const [building, setBuilding] = useState("all");
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");

  const buildingsQ = useQuery({
    queryKey: ["ref", "buildings"],
    queryFn: () => api.reference.buildings(),
  });
  const listQ = useQuery({
    queryKey: ["tenants", { building, status }],
    queryFn: () => api.tenants.list({ building, status }),
  });

  const all = listQ.data?.tenants ?? [];
  const term = q.trim().toLowerCase();
  const rows = term ? all.filter((t) => t.name.toLowerCase().includes(term)) : all;

  return (
    <Layout title="Tenants">
      <div className="page-actions">
        <Link to="/tenants/new" className="btn btn-primary btn-xl">
          + Add a tenant
        </Link>
        <Link to="/eviction-list" className="btn btn-ghost btn-xl">
          Eviction list
        </Link>
      </div>

      <div className="filters">
        <label className="field">
          <span>Search</span>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type a name..." />
        </label>
        <label className="field">
          <span>Building</span>
          <select value={building} onChange={(e) => setBuilding(e.target.value)}>
            <option value="all">All buildings</option>
            {(buildingsQ.data?.buildings ?? []).map((b) => (
              <option key={b.id} value={String(b.id)}>
                {b.name}
              </option>
            ))}
          </select>
        </label>
        <label className="field">
          <span>Status</span>
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="all">All</option>
            {TENANT_STATUSES.map((s) => (
              <option key={s} value={s}>
                {tenantStatusLabel(s)}
              </option>
            ))}
          </select>
        </label>
      </div>

      <section className="card">
        {listQ.isLoading ? (
          <p className="sub">Loading…</p>
        ) : listQ.isError ? (
          <p className="sub">Could not load tenants. Please try again.</p>
        ) : rows.length === 0 ? (
          <p className="sub">No tenants match these filters.</p>
        ) : (
          <div className="table-wrap stack-md">
            <table>
              <thead>
                <tr>
                  {COLUMNS.map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((t) => (
                  <tr key={t.id}>
                    <td data-label="Name">
                      <Link to={`/tenants/${t.id}`} className="wo-title-link">
                        {t.name}
                      </Link>
                    </td>
                    <td data-label="Building">{t.buildingName}</td>
                    <td data-label="Unit">{t.where}</td>
                    <td data-label="Status">
                      <span className={`badge badge-${tenantStatusBadge(t.status)}`}>
                        {tenantStatusLabel(t.status)}
                      </span>
                    </td>
                    <td data-label="Phone">{t.phone ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </Layout>
  );
}
